import React from 'react';
// import { connect } from 'react-redux';
import { Drawer, notification } from 'antd';
import CreateTaskForm from './Task/TaskCreateOrUpdate/TaskCreateOrUpdate';
import TaskDetails from './Task/TaskDetails/TaskDetials';
import drawerActions from '@iso/redux/drawer/actions';
import { createGlobalStyle } from 'styled-components';
import { useContext } from 'react';
import { AppContext } from '../../context/ContextProvider';
import { featureEnabled, isPersonalWorkspace } from '../../context/helper';
import ClusterProd from '../Clusters/Task/ClusterProd';
import ClusterDev from '../Clusters/Task/ClusterDev';
import ClusterNonDev from '../Clusters/Task/ClusterNonDev';
import CodeView from '../Clusters/Task/CodeView';
import SecurityDrawerData from '../Dashboard/SecurityVulnerabilities/SecurityDrawerData';
import AddEnvironmentVariable from '../Projects/AddEnvironmentVariable';
import BasicDetails from '../Deployments/ApplicationBasicDetails';
import GcpIntgration from '../Pages/CloudProviders/GcpIntgration';
import AwsIntegration from '../Pages/CloudProviders/AwsIntegration';
import DockerHubIntgration from '../Pages/CloudProviders/DockerHubIntgration';
import EcrIntgration from '../Pages/CloudProviders/EcrIntgration';
import CloudFlareIntgration from '../Pages/CloudProviders/CloudFlareIntegration';
import SecurityDrawerTypeData from '../Dashboard/SecurityVulnerabilities/SecurityTypeDrawerData';
import ImportEnvironmentVariable from '../Projects/ImportEnvironmentVariable';
import ClusterMarketplaceDrawer from '../Clusters/Task/ClusterMarketplaceDrawer';
import PglStackDrawer from '../Clusters/Task/PglStackDrawer';
import AddonsOverview from '../Clusters/Task/AddonsOverview';
import K8sDashboardDrawer from '../Clusters/Task/K8sDashboardDrawer';
import PrebuildToolsRightDrawer from '../Projects/WorkflowPages/PrebuildToolsRightDrawer';
import CustomScriptRightDrawer from '../Projects/WorkflowPages/CustomScriptRightDrawer';
import SourceToolsRightDrawer from '../Projects/WorkflowPages/SourceToolsRightDrawer';
import postBuildToolsRightDrawer from '../Projects/WorkflowPages/PostBuildToolsRightDrawer';
import BuildToolsRightDrawer from '../Projects/WorkflowPages/BuildToolsRightDrawer';
import ToolsEditRightDrawer from '../Projects/WorkflowPages/ToolsEditRightDrawer';
import ArgoFlowDrawer from '../Clusters/Task/ArgoFlowDrawer';
import OnSourceClickRightDrawer from '../Projects/WorkflowPages/OnSourceClickRightDrawer';
import OnBuildClickRightDrawer from '../Projects/WorkflowPages/OnBuildClickRightDrawer';
import OnDeployClickRightDrawer from '../Projects/WorkflowPages/OnDeployClickRightDrawer';
import GuardrailInfoDrawer from '../Guardrails/GuardrailModals/GuardrailInfoDrawer';
import OneClickClusterDrawer from '../Clusters/Task/OneClickClusterDrawer';
import GitlabIntegration from '../Pages/CloudProviders/GitlabIntegration';
import PostDeployToolsRightDrawer from '../Projects/WorkflowPages/PostDeployToolsRightDrawer';
import DeployToolsRightDrawer from '../Projects/WorkflowPages/DeployToolsRightDrawer';
import PostBuildCustomScriptRightDrawer from '../Projects/WorkflowPages/PostBuildCustomScriptRightDrawer';
import PostDeployCustomScriptRightDrawer from '../Projects/WorkflowPages/PostDeployCustomScriptRightDrawer';
import WorkflowTemplatesRightDrawer from '../Projects/WorkflowPages/WorkflowTemplatesRightDrawer';
import BringYourClusterDrawer from '../Clusters/Task/BringYourClusterDrawer';
import PostPushCustomScriptRightDrawer from '../Projects/WorkflowPages/PostPushCustomScriptRightDrawer';
import OnPushClickRightDrawer from '../Projects/WorkflowPages/OnPushClickRightDrawer';
import FailedControlsDrawer from '../Clusters/Task/ClusterSecurityScans/FailedControlsDrawer';
import InfraAddNewEnvVars from '../Projects/infra-module/InfraAddNewEnvVars';
import InfraSourceRightDrawer from '../Projects/infra-module/infraWorkflowBuilderPages/InfraSourceRightDrawer';
import InfraApplyRightDrawer from '../Projects/infra-module/infraWorkflowBuilderPages/InfraApplyRightDrawer';
import AssignRole from '../ObjectRolesAndPermissions/AssignRole';
import AdvanceYamlInfoRightDrawer from '../Deployments/AdvanceYamlInfoRightDrawer';
import InfraImportEnvVars from '../Projects/infra-module/InfraImportEnvVars';
import AIAgent from '../AIChat/AIAgent/AIAgent';
import K8sAICopilot from '../AIChat/K8sAICopilot/K8sAICopilot';
import HealthIssuesRightDrawer from '../Deployments/HealthIssuesRightDrawer';
import ExtraWarningsDrawer from '../Clusters/Task/ExtraWarningsDrawer';
import AwsIntegrationPoliciesDrawer from '../Clusters/Task/AwsIntegrationPoliciesDrawer';
import WorkflowConfiguration from '../Projects/WorkflowPages/WorkflowConfiguration';
import GcrIntgration from '../Pages/CloudProviders/GcrIntegration';
import ExternalIdSetupDrawer from '../CredentialsManagement/ExternalIdSetupDrawer';
import SecretManagerIntegration from '../Pages/CloudProviders/SecretManagerIntegration';
import GcpSecretManagerIntegration from '../Pages/CloudProviders/GcpSecretManagerIntegration';
import AddNewEnvVars from '../Projects/AddNewEnvVars';
import ImportNewEnvVars from '../Projects/ImportNewEnvVars';
import AddBlueprintEnvironmentVariable from '../ApplicationBlueprint/Steps/AddBlueprintEnvironmentVariable';
import ImportBlueprintEnvironmentVariable from '../ApplicationBlueprint/Steps/ImportBlueprintEnvironmentVariable';

const DrawerStyles = createGlobalStyle`
  .ant-drawer .ant-drawer-body{
    padding: 0;
  }
  .ant-drawer-content-wrapper{
    width: 100% !important;
    @media (min-width: 768px){
      width: 500px!important;
    }
    @media (min-width: 1200px){
      width: 700px!important;
    }
  }
`;

const DrawerStylesExpended = createGlobalStyle`
  .ant-drawer .ant-drawer-body{
    padding: 0;
  }
  .ant-drawer-content-wrapper{
    width: 100% !important;
    @media (min-width: 768px){
      width: 700px!important;
    }
    @media (min-width: 1200px){
      width: 900px!important;
    }
  }
`;

const DrawerStylesHealthIssues = createGlobalStyle`
  .ant-drawer .ant-drawer-body{
    padding: 0;
  }
  .ant-drawer-content-wrapper{
    width: 100% !important;
    @media (min-width: 768px){
      width: 65vw!important;
    }
    @media (min-width: 1200px){
      width: 70vw!important;
    }
  }
`;

const DrawerStylesAICopilot = createGlobalStyle`
  .ant-drawer .ant-drawer-body{
    padding: 0;
  }
  .ant-drawer-content-wrapper{
    width: 100% !important;
    @media (min-width: 768px){
      width: 75vw!important;
    }
    @media (min-width: 1200px){
      width: 75vw!important;
    }
  }
`;

const DRAWER_COMPONENTS = {
  CREATE_OR_EDIT_TASK: CreateTaskForm,
  CARD_DETAILS: TaskDetails,
  MORE_INFO_TASK: TaskDetails,
  prod: ClusterProd,
  existingVpc: ClusterProd,
  dev: ClusterDev,
  'non-prod': ClusterNonDev,
  'prodCodeView': CodeView,
  'security': SecurityDrawerData,
  'securityScan': SecurityDrawerTypeData,
  'addEnvironmentVariable': AddEnvironmentVariable,
  'addInfraEnvironmentVariable': InfraAddNewEnvVars,
  'addNewEnvironmentVariable': AddNewEnvVars,
  'addBlueprintEnvironmentVariable': AddBlueprintEnvironmentVariable,
  'importEnvironmentVariable': ImportEnvironmentVariable,
  'importInfraEnvironmentVariable': InfraImportEnvVars,
  'importNewEnvironmentVariable': ImportNewEnvVars,
  'importBlueprintEnvironmentVariable': ImportBlueprintEnvironmentVariable,
  'gcpintegration': GcpIntgration,
  'awsintegration': AwsIntegration,
  'gitlab-integration': GitlabIntegration,
  'dockerhubintegration': DockerHubIntgration,
  'ecrintegration': EcrIntgration,
  'gcrintegration': GcrIntgration,
  'secret_manager_integration': SecretManagerIntegration,
  'gcp_secret_manager_integration': GcpSecretManagerIntegration,
  'cloudflareintegration': CloudFlareIntgration,
  'clusterMarketplaceDrawer': ClusterMarketplaceDrawer,
  'pgl_stack': PglStackDrawer,
  'addons_overview': AddonsOverview,
  'guardrailNodeInfo': GuardrailInfoDrawer,
  'k8s_dashboard': K8sDashboardDrawer,
  'argo_flow': ArgoFlowDrawer,
  'sourceClickRightDrawer': OnSourceClickRightDrawer,
  'infraSourceClickRightDrawer': InfraSourceRightDrawer,
  'infraApplyClickRightDrawer': InfraApplyRightDrawer,
  'buildClickRightDrawer': OnBuildClickRightDrawer,
  'deployClickRightDrawer': OnDeployClickRightDrawer,
  'pushClickRightDrawer': OnPushClickRightDrawer,
  'prebuildRightDrawer': PrebuildToolsRightDrawer,
  'postDeployRightDrawer': PostDeployToolsRightDrawer,
  'customScript': CustomScriptRightDrawer,
  'post-build-customScript': PostBuildCustomScriptRightDrawer,
  'postDeployCustomScript': PostDeployCustomScriptRightDrawer,
  'post-push-customScript': PostPushCustomScriptRightDrawer,
  'sourceTools': SourceToolsRightDrawer,
  'postBuildRightDrawer': postBuildToolsRightDrawer,
  'buildTools': BuildToolsRightDrawer,
  'deployTools': DeployToolsRightDrawer,
  // 'deployStep': OnDeployClickRightDrawer,
  'toolsEdit': ToolsEditRightDrawer,
  'workflowTemplates': WorkflowTemplatesRightDrawer,
  'oneClickCluster': OneClickClusterDrawer,
  'bringYourCluster':BringYourClusterDrawer,
  'failedControls': FailedControlsDrawer,
  'assignRole': AssignRole,
  'workflowConfigClickRightDrawer': WorkflowConfiguration,
  'extraWarnings': ExtraWarningsDrawer,
  'awsIntegrationPoliciesGuide': AwsIntegrationPoliciesDrawer,
  'aiAgent': AIAgent,
  'k8sAICopilot': K8sAICopilot,
  'healthIssues': HealthIssuesRightDrawer,
  'advanceYamlInfoRightDrawer': AdvanceYamlInfoRightDrawer,
  'externalIdSetup': ExternalIdSetupDrawer,
  /* other modals */
};

const DrawerRoot = ({
  // drawerType,
  // drawerProps,
  // drawerVisibility,
  // closeDrawer,
  // openDrawer,
}) => {
  
  const {openRightDrawer, setOpenRightDrawer} = useContext(AppContext);
  const SpecificDrawer = DRAWER_COMPONENTS[openRightDrawer.drawerType];

  if (!openRightDrawer.drawerType) {
    return null;
  }

  // AI analysis is not part of the Personal (single-user) plan, and the
  // `ai_assistant` capability can be switched off per org in Super Admin →
  // Organisation Plans — block the AI drawers at the single mount point rather
  // than at every trigger button.
  if (['aiAgent', 'k8sAICopilot'].includes(openRightDrawer.drawerType)
      && (isPersonalWorkspace() || !featureEnabled('ai_assistant'))) {
    notification.info({
      message: isPersonalWorkspace()
        ? 'AI assistant is not available on the Personal plan'
        : 'AI assistant is not enabled for your organisation',
      description: 'Upgrade to a team plan to use AI-powered analysis and the Kubernetes copilot.',
      duration: 4,
    });
    setOpenRightDrawer({ drawerType: false, drawerProps: { data: null, columnId: null } });
    return null;
  }

  return (
    <Drawer
      placement="right"
      closable={false}
      zIndex={1200}
      onClose={() => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
              data: null,
              columnId: null,
            },
          });
      }}
      open={openRightDrawer.drawerType}
      // width={700}
      destroyOnClose={true}
      className={openRightDrawer?.drawerProps?.className ? openRightDrawer.drawerProps.className : ""}
    >
      {openRightDrawer?.drawerProps?.className === "expend" ? <DrawerStylesExpended /> : 
       openRightDrawer.drawerType === "healthIssues" ? <DrawerStylesHealthIssues /> :
       openRightDrawer.drawerType === "k8sAICopilot" ? <DrawerStylesAICopilot /> : <DrawerStyles />}

      <SpecificDrawer
        {...openRightDrawer.drawerProps}
        openDrawer={() => {
          setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
              data: null,
              columnId: null,
            },
          });
        }}
        closeDrawer={() => {
          setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
              data: null,
              columnId: null,
            },
          });
        }}
      />
    </Drawer>
  );
};

export default DrawerRoot

// export default connect(
//   state => state.drawer,
//   { ...drawerActions }
// )(DrawerRoot);
